jQuery( document ).ready(function() {
    var helem = jQuery(".same-height").innerHeight();
    jQuery(".same-height-set").height(helem);
});